import Link from 'next/link';

const StudyPaperRefrenceURL =
  'https://www.frontiersin.org/articles/10.3389/fpsyg.2021.744209/full';

export type FAQQuestions = typeof FAQQuestions;
export const FAQQuestions = [
  {
    question: 'How do I get email reminders to check Time Machine?',
    answer:
      'Email notifications are enabled by default. Please check your spam folder if you do not see the Time Machine emails.',
  },
  {
    question: 'Why can’t I record messages on my iPhone or iPad?',
    answer: 'Please upgrade to the latest version of iOS for the best results.',
  },
  {
    question: 'Which browser should I use?',
    answer: 'We recommend Google Chrome or Safari.',
  },
  {
    question: 'What is Time Machine?',
    answer:
      'Time Machine is an evidence-based progressive web app designed to help people connect with themselves and others in positive, loving ways. It is based on the effectiveness of "time-travel narratives" — a proven therapeutic method that supports people in getting to know, forgive, and love their internal representations of their past, present, and future selves.',
  },
  {
    question:
      'What makes Time Machine non-addictive and positive habit forming? ',
    answer:
      'The focus is on individual healing and the community. There’s no way to be individually critiqued or validated in the app, so addiction mechanisms are not triggered. Providing 24-hour enrichment opportunities supports people in leaving the app. And by giving daily notifications, people are reminded that Time Machine is available if they want to make it into a positive habit.',
  },
  {
    question: 'Why did Applied Love Labs make Time Machine?',
    answer:
      'Our team created Time Machine because, in our own lives, we knew how lovingly connecting with all aspects of ourselves — even the parts we were ashamed of or afraid of — have helped us survive and even thrive. We wanted to bring this idea to an accessible technology that does not support negative interactions or addiction. We call this type of technology, "Hope Technology.”',
  },
  {
    question: 'How does Time Machine work?',
    answer:
      'Time Machine creates an unconditionally loving environment that trains people to accept and forgive their past selves, and accept help and love from their future selves. Learning to love yourself over time is key to overall wellbeing.',
  },
  {
    question: 'Why do I need to do wellness check every day?',
    answer:
      'To remind yourself that you matter, and you are learning to recognize subtle variations in your feelings that will make a difference over time.',
  },
  {
    question: 'How do I unlock the Meditation Tent?',
    answer:
      'Use the Time Machine for 2 days. Time Machine uses this task flow because we have found people do best building positive habits when they learn one new task at a time.',
  },
  {
    question: 'How do I unlock the Hope Garden?',
    answer:
      'Use the Time Machine for 4 days. Time Machine uses this task flow because we have found people do best building positive habits when they learn one new task at a time.',
  },
  {
    question: 'Where are my saved Time Machine messages?',
    answer:
      'Time Machine messages are saved to the “Time Travel” category in the Meditation Tent. If you don’t save your Time Machine messages, they are deleted after you listen to them.',
  },
  {
    question: 'Who can hear my messages and meditations?',
    answer:
      'Time Machine messages and Meditations are private and can only be heard by you. Messages shared to the Community Garden can be heard by all hope gardeners.',
  },
  {
    question:
      'What should I do if a hope in the Community Garden is offensive?',
    answer:
      'You have three options. First, you can mute that particular hope – this will remove it from your Community Garden. Or, you can mute the user and never see any of their hopes again. Finally, you can flag offensive hopes – this will remove that particular hope and result in the user being banned from the Community Garden.',
  },
  {
    question: 'How can I watch the introductory video?',
    answer: (
      <p>
        Check it out{' '}
        <Link href="/help?tab=video" passHref>
          here
        </Link>
      </p>
    ),
  },
  {
    question: 'I want step-by-step instructions for a part of the app.',
    answer: (
      <p>
        Check it out the How to{' '}
        <Link href="/help?tab=howto" passHref>
          guides
        </Link>
      </p>
    ),
  },
  {
    question: 'How can I learn more about Time Machine?',
    answer: (
      <a href={StudyPaperRefrenceURL} target="_blank" rel="noreferrer">
        Read our paper.
      </a>
    ),
  },
  {
    question: 'I want more help',
    answer: (
      <p>
        Contact support:{' '}
        <a href="mailto:help@applied.love">help@applied.love</a>
      </p>
    ),
  },
].map((item, idx) => ({ ...item, id: idx }));
